import { Aws, Azure, Gcp } from "../icons";

const CLOUD_ICONS = { AWS: Aws, AZURE: Azure, GCP: Gcp };

// Case-insensitive cloud-name -> logo lookup, shared by every place that
// renders a bare cloud badge (Environments table, the details drawer).
const CloudIcon = ({ cloud, size = "16px" }) => {
  const Icon = cloud && CLOUD_ICONS[String(cloud).toUpperCase()];
  return Icon ? <Icon size={size} /> : null;
};

export default CloudIcon;
